<template>
  <div>
    <section class="container">
      <div class="management_top_box">
        <h4>{{ $t("management.qnaManagement") }}</h4>
      </div>
      <div class="wrap_con type_bt_wrap">
        <div class="mb-5 pb-3">
          <div class="float-end">
            <div class="list_top_search d-flex">
              <input
                type="text"
                id="searchWord"
                v-model="form.searchWord"
                name="searchWord"
                value=""
                class="m-1 form-control"
              />
              <select
                id="searchClass"
                v-model="form.searchClass"
                class="m-1 form-control"
              >
                <option value="">--{{ $t("common.classify") }}--</option>
                <option
                  v-for="(clazz, index) in classList"
                  :key="index"
                  :value="clazz.classId"
                >
                  {{ clazz.className }}
                </option>
              </select>
              <select
                id="searchState"
                v-model="form.searchState"
                class="m-1 form-control"
              >
                <option value="">--{{ $t("common.state") }}--</option>
                <option value="Y">{{ $t("support.qna.answered") }}</option>
                <option value="N">{{ $t("support.qna.answering") }}</option>
              </select>
              <a
                id="btnSearch"
                @click="searchBtn"
                href="#"
                class="btn btn-primary btn-lg"
                >{{ $t("common.search") }}</a
              >
            </div>
          </div>
        </div>
        <div>
          <a
            id="btnSearch"
            @click="[chgState(''), fetchData(1), (flag = 'all')]"
            href="#"
            class="btn btn-lg"
            style="width: 100px"
            :class="flag == 'all' ? 'btn-primary' : 'btn-dark'"
            >{{ $t("common.all") }}</a
          >
          <a
            id="btnSearch"
            @click="[chgState('N'), fetchData(1), (flag = 'my')]"
            href="#"
            class="btn btn-lg"
            :class="flag == 'my' ? 'btn-primary' : 'btn-dark'"
            >{{ $t("common.goingToAnswer") }}</a
          >
        </div>
        <div>
          <table class="list_tbl">
            <thead>
              <tr>
                <th class="mobile_row">{{ $t("common.title") }}</th>
                <th class="mobile_h">{{ $t("common.classify") }}</th>
                <th class="mobile_h">{{ $t("common.state") }}</th>
                <th class="mobile_h">{{ $t("common.writer") }}</th>
                <th class="mobile_h">{{ $t("common.date") }}</th>
                <th class="mobile_h">{{ $t("common.file") }}</th>
                <th class="mobile_h">{{ $t("common.hits") }}</th>
              </tr>
            </thead>
            <tbody v-if="items.length != 0">
              <tr
                v-for="(item, index) in items"
                :key="index"
                @click="goQnaView(item)"
                class="active_mouseover"
              >
                <td v-if="item.parent == null" class="pointer text-left">
                  {{ item.title }}
                </td>
                <td
                  v-else
                  class="pointer text-left answer-span"
                  :style="{ 'padding-left': 40 * item.depth + 'px' }"
                >
                  <span>A</span>{{ item.title }}
                </td>
                <td>{{ item.className }}</td>
                <td>
                  {{
                    item.state == "Y"
                      ? $t("support.qna.answered")
                      : $t("support.qna.answering")
                  }}
                </td>
                <td>{{ item.firstRegrName }}</td>
                <td>{{ item.firstRegDatetime }}</td>
                <td v-if="item.filecount > 0">
                  <img
                    src="../../../../src/img/background/view_file_icon.png"
                    alt="file"
                  />
                </td>
                <td v-else></td>
                <td v-if="item.parent == null">
                  {{ item.hitno }}
                </td>
                <td v-else></td>
                <!-- <td>{{ item.hitno }}</td> -->
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">{{ $t("common.noData") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="items.length != 0" class="paging_nav">
          <a
            href="javascript:void(0)"
            v-if="pagingVO.startPage <= pagingVO.blockSize"
            class="page_select prev_page disabled"
            >이전페이지 이동</a
          >
          <a
            v-else
            class="page_select prev_page"
            @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
            v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
            >이전페이지 이동</a
          >
          <span
            v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
            :key="index"
          >
            <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
              pagingVO.startPage + index
            }}</strong>
            <a
              href="javascript:void(0)"
              v-else
              @click="searchPage(pagingVO.startPage + index)"
              >{{ pagingVO.startPage + index }}</a
            >
          </span>
          <a
            v-if="pagingVO.endPage >= pagingVO.totalPage"
            href="javascript:void(0)"
            class="page_select next_page disabled"
            >다음페이지 이동</a
          >
          <a
            v-else
            href="javascript:void(0)"
            @click="searchPage(pagingVO.endPage + 1)"
            v-bind:data-page="pagingVO.endPage + 1"
            class="page_select next_page"
            >다음페이지 이동</a
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getQnaMgmtList } from "@/api/qna";

export default {
  data() {
    return {
      items: "",
      pagingVO: "",
      form: {
        searchWord: "",
        searchState: "",
        searchClass: "",
        startDate: "",
        endDate: "",
        page: 1,
      },
      classList: [],
      boardId: "",
      component: null,
      componentName: null,
      flag: "all",
    };
  },
  created() {
    if (this.$store.getters.getSearchObj != "") {
      this.form = this.$store.getters.getSearchObj;
      if (this.$store.getters.getPage != 1) {
        this.form.page = this.$store.getters.getPage;
        this.fetchData(this.form.page);
      } else {
        this.fetchData(this.form.page);
      }
    } else {
      this.fetchData(this.form.page);
    }
  },
  methods: {
    async fetchData(page) {
      try {
        this.form.page = page;
        const response = await getQnaMgmtList(this.form);
        this.items = response.data.pagingVO.dataList;
        this.pagingVO = response.data.pagingVO;
        this.classList = response.data.classList;
        // 기존 검색 값 유지
        if (response.data.searchObj != null) {
          this.form = response.data.searchObj;
        }
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData(this.form.page);
    },
    searchBtn() {
      // 검색기능
      this.form.page = 1;
      this.$store.commit("setSearchObj", this.form);
      this.fetchData(this.form.page);
    },
    chgState(state) {
      this.form.searchState = state;
    },
    goQnaView(board) {
      this.$router.push({ name: "mgmtQnaView", query: { boardId: board.boardId } });
      // this.$router.push({ name: "mgmtQnaView", params: { boardId: board.boardId } });
    },
  },
};
</script>

<style></style>
